import Button, { ButtonProps } from '../ui/button';

export default function AuthSubmit({
	isLoading,
	label = 'Submit',
	size = 'medium',
	fullWidth = true,
	transition = 'none',
	...props
}: Readonly<ButtonProps>) {
	return (
		<Button
			type="submit"
			isLoading={isLoading}
			disabled={isLoading}
			fullWidth={fullWidth}
			size={size}
			transition={transition}
			{...props}
		>
			{label}
		</Button>
	);
}
